import { observer } from 'mobx-react';
import * as React from 'react';

export interface IFooterParams {
    id?: string;
    canShow?: boolean;
}

@observer
export class FooterContainer extends React.Component<IFooterParams> {

    elementId: string = "reactFooterWrapper";

    render() {
        return <div id={this.elementId} style={{ display: this.props.canShow ? "block" : "none" }}>
            {/*<div>footer footer footer</div>*/}
        </div>
    };

    componentDidMount() {
        eval("if (window.reactLive) {window.reactLive.tools.fixFooter('" + this.elementId + "');reactLive.tools.checkResponsiveFooter();}"); /* TODO use aspxNotification! */
    }

    componentWillUnmount() {
        eval("if (window.reactLive) {window.reactLive.tools.returnFooter('" + this.elementId + "');}");
    }
}